import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, scheduled, asyncScheduler } from 'rxjs';

import { WizardStep } from './wizard-step.interface';

@Component({
    selector: 'wizard-step',
    templateUrl: './wizard-step.component.html',
    styleUrls: ['./wizard-step.component.scss'],

    imports: [
        CommonModule
    ],
})
export class WizardStepComponent implements OnInit {
    @Input()
    title: string = '';

    @Input()
    public active: boolean = false;

    @Input()
    public completed: boolean = false;

    @Input()
    public valid: boolean = true;

    @Input()
    public allowPrevious: boolean = true;

    @Input()
    public hideDefaultButtons: boolean = false;

    @ContentChild(TemplateRef)
    public childTemplate!: TemplateRef<any>;

    @Input()
    public wizardStepInstance!: WizardStep;

    ngOnInit(): void {
        // Component initialized
    }

    onActivate(stepIndex: number): void {
        this.active = true;

        stepIndex = stepIndex - 1;
        localStorage.setItem('lastActiveStepIndex', stepIndex.toString());

        if (this.wizardStepInstance) {
            this.wizardStepInstance.onActivate();
        }
    }

    onNext(): Observable<boolean> {
        if (this.wizardStepInstance && this.wizardStepInstance.isValid()) {
            return this.wizardStepInstance.onNext();
        }

        return scheduled([false], asyncScheduler);
    }

    onPrevious(): Observable<boolean> {
        if (this.wizardStepInstance) {
            return this.wizardStepInstance.onPrevious();
        }

        return scheduled([false], asyncScheduler);
    }

    saveData(): Observable<boolean> {
        // Simulate async save
        return scheduled([true], asyncScheduler);
    }
}
